/* Customima · Home nueva: interacción de las secciones cm-home-*. Sin dependencias. */
(function () {
  if (window.__cmhInit) return;
  window.__cmhInit = true;

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  window.dataLayer = window.dataLayer || [];
  function track(event, params) { var o = { event: event }; for (var k in (params || {})) o[k] = params[k]; window.dataLayer.push(o); }

  function init() {
    /* Tracking genérico */
    document.addEventListener('click', function (e) {
      var el = e.target.closest('[data-cmh-track]');
      if (el) track(el.getAttribute('data-cmh-track'), { label: el.getAttribute('data-cmh-label') || '', position: el.getAttribute('data-cmh-pos') || '' });
    });

    /* Hero: etiqueta sobre la joya (sigue a object-fit: cover y object-position) */
    $$('[data-cmh-hs]').forEach(function (hs) {
      var img = hs.parentNode.querySelector('img');
      function place() {
        if (!img || !img.naturalWidth) return;
        var b = img.getBoundingClientRect(), w = b.width, h = b.height;
        var sc = Math.max(w / img.naturalWidth, h / img.naturalHeight);
        var dw = img.naturalWidth * sc, dh = img.naturalHeight * sc;
        var op = (getComputedStyle(img).objectPosition || '50% 50%').split(' ');
        var fx = op[0] && op[0].indexOf('%') > -1 ? parseFloat(op[0]) / 100 : 0.5;
        var fy = op[1] && op[1].indexOf('%') > -1 ? parseFloat(op[1]) / 100 : 0.5;
        hs.style.left = ((w - dw) * fx + parseFloat(hs.dataset.x) / 100 * dw) + 'px';
        hs.style.top = ((h - dh) * fy + parseFloat(hs.dataset.y) / 100 * dh) + 'px';
      }
      if (img.complete) place(); else img.addEventListener('load', place);
      window.addEventListener('resize', place);
    });

    /* Pestañas accesibles */
    $$('[data-cmh-tabs]').forEach(function (list) {
      var tabs = $$('[role="tab"]', list);
      function select(t) {
        tabs.forEach(function (x) {
          var on = x === t; x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1;
          var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on;
        });
        track('finder_tab_change', { tab: t.dataset.tab });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          var j = null;
          if (e.key === 'ArrowRight') j = (i + 1) % tabs.length;
          if (e.key === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
          if (j !== null) { e.preventDefault(); tabs[j].focus(); select(tabs[j]); }
        });
      });
    });

    /* Selector por persona + presupuesto */
    $$('[data-cmh-finder]').forEach(function (root) {
      var budget = 'all';
      var people = $$('[data-cmh-person]', root);
      function applyBudget() {
        $$('[data-cmh-panel]', root).forEach(function (panel) {
          var shown = 0;
          $$('[data-price]', panel).forEach(function (it) {
            var p = parseFloat(it.dataset.price);
            var ok = budget === 'all' || (budget === '50' ? p <= 50 : budget === '100' ? p > 50 && p <= 100 : p > 100);
            it.hidden = !ok; if (ok) shown++;
          });
          var empty = $('[data-cmh-empty]', panel); if (empty) empty.hidden = shown > 0;
        });
      }
      function show(key, source) {
        people.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.cmhPerson === key)); });
        $$('[data-cmh-panel]', root).forEach(function (p) { p.hidden = p.dataset.cmhPanel !== key; });
        if (source) track('recipient_click', { recipient: key, source: source });
      }
      people.forEach(function (b) { b.addEventListener('click', function () { show(b.dataset.cmhPerson, 'finder'); }); });
      $$('[data-cmh-budget]', root).forEach(function (c) {
        c.addEventListener('click', function () {
          budget = c.dataset.cmhBudget;
          $$('[data-cmh-budget]', root).forEach(function (x) { x.setAttribute('aria-pressed', String(x === c)); });
          applyBudget(); track('budget_filter', { range: budget });
        });
      });
      if (people[0]) show(people[0].dataset.cmhPerson);
      applyBudget();
    });

    /* Hilo conductor: puentes entre dudas, índice lateral y barra de progreso */
    var secs = $$('[data-cmh-q]').filter(function (s) { return s.dataset.cmhQ; });
    secs.forEach(function (s, i) {
      var next = secs[i + 1];
      if (!next || s.dataset.cmhBridge !== 'true' || !next.id) return;
      var wrap = $('.cmh-wrap', s) || s;
      var a = document.createElement('a');
      a.className = 'cmh-next'; a.href = '#' + next.id;
      a.setAttribute('data-cmh-track', 'thread_next'); a.setAttribute('data-cmh-label', next.dataset.cmhQ);
      a.innerHTML = '<span></span><svg class="cmh-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
      a.firstChild.textContent = next.dataset.cmhQ;
      wrap.appendChild(a);
    });
    var navItems = secs.filter(function (s) { return s.dataset.cmhNav === 'true' && s.id; });
    if (navItems.length > 2) {
      var nav = document.createElement('nav');
      nav.className = 'cmh cmh-thread'; nav.setAttribute('aria-label', 'Recorrido de la página');
      var ol = document.createElement('ol');
      navItems.forEach(function (s) {
        var li = document.createElement('li'), a = document.createElement('a'), sp = document.createElement('span');
        a.href = '#' + s.id; a.dataset.for = s.id; sp.textContent = s.dataset.cmhQ; a.appendChild(sp); li.appendChild(a); ol.appendChild(li);
      });
      nav.appendChild(ol); document.body.appendChild(nav);
      var links = $$('a', nav);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (en) {
            if (!en.isIntersecting) return;
            links.forEach(function (a) { if (a.dataset.for === en.target.id) a.setAttribute('aria-current', 'step'); else a.removeAttribute('aria-current'); });
          });
        }, { rootMargin: '-45% 0px -50% 0px' });
        navItems.forEach(function (s) { io.observe(s); });
      }
      var first = navItems[0], last = navItems[navItems.length - 1];
      window.addEventListener('scroll', function () {
        var y = window.scrollY + window.innerHeight * 0.5;
        nav.classList.toggle('is-on', y > first.offsetTop && y < last.offsetTop + last.offsetHeight);
      }, { passive: true });
    }

    /* FAQ y vistas de sección */
    $$('.cmh-faq details').forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) track('faq_open', { question: d.querySelector('summary').textContent.trim() }); }); });
    if ('IntersectionObserver' in window) {
      var seen = {};
      var sio = new IntersectionObserver(function (es) { es.forEach(function (en) { var id = en.target.id; if (en.isIntersecting && !seen[id]) { seen[id] = 1; track('section_view', { section_id: id }); } }); }, { threshold: 0.35 });
      $$('.cmh[id]').forEach(function (s) { sio.observe(s); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
